import { Input } from '@platform/design-system';
import { usePageContext } from '../usePageContext.ts';
import { clampCopies, MAX_COPIES_PER_VARIANT, type Copies, type LabelSubject } from './labels.ts';
import styles from './Labels.module.css';

export type LabelLinesProps = {
  subjects: readonly LabelSubject[];
  copies: Copies;
  onCopiesChange: (variantId: string, count: number) => void;
};

const titleOf = (subject: LabelSubject): string =>
  subject.options === '' ? subject.name : `${subject.name} · ${subject.options}`;

export const LabelLines = ({ subjects, copies, onCopiesChange }: LabelLinesProps) => {
  const { t } = usePageContext();
  return (
    <ul className={styles['lines']}>
      {subjects.map((subject) => (
        <li key={subject.variantId} className={styles['line']}>
          <span className={styles['lineText']}>
            <span>{titleOf(subject)}</span>
            <span className={styles['lineSku']} dir="ltr">
              {subject.sku}
            </span>
          </span>
          <Input
            className={styles['copies']}
            type="number"
            inputMode="numeric"
            min={0}
            max={MAX_COPIES_PER_VARIANT}
            label={t('labels.copiesOf', { name: titleOf(subject) })}
            hideLabel
            value={copies[subject.variantId] ?? 0}
            onChange={(event) => {
              onCopiesChange(subject.variantId, clampCopies(event.target.valueAsNumber));
            }}
          />
        </li>
      ))}
    </ul>
  );
};
